import { createFileRoute, notFound } from "@tanstack/react-router";
import { MISC_OFFICIAL_QA, MISC_OFFICIAL_QA_BY_SLUG, MISC_OFFICIAL_REVIEWED_ISO, MISC_OFFICIAL_REVIEWED_TH } from "@/data/misc-official/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = { base: "/misc-official", label: "เอกสารราชการเฉพาะเรื่อง", reviewedIso: MISC_OFFICIAL_REVIEWED_ISO, reviewedTh: MISC_OFFICIAL_REVIEWED_TH };

export const Route = createFileRoute("/misc-official/q/$slug")({
  loader: ({ params }) => { if (!MISC_OFFICIAL_QA_BY_SLUG[params.slug]) throw notFound(); return { slug: params.slug }; },
  head: ({ loaderData }) => clusterQaDetailHead(M, loaderData ? MISC_OFFICIAL_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = MISC_OFFICIAL_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={MISC_OFFICIAL_QA} />;
}
